var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    transform: "translate(0.5)",
    fill: "#FFD018"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 4.5,
    fill: "#DC251C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 13.5,
    width: 24,
    height: 4.5,
    fill: "#DC251C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 3,
    height: 3,
    fill: "#DC251C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H8V12H6C5.44772 12 5 11.5523 5 11V9Z",
    fill: "#FF8718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H11V11C11 11.5523 10.5523 12 10 12H8V9Z",
    fill: "#DC251C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 3,
    height: 3,
    fill: "#A6A6A6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 0.75,
    fill: "#41479B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.958f818f.svg";
export { ForwardRef as ReactComponent };